import { OrganizationSize } from "@mapmycustomers/shared/types/OrganizationSize";

import loggingService from "@app/util/logging";

// precision for maps endpoint based on current zoom level
// would like these objects not sorted alphabetically
/* eslint-disable perfectionist/sort-objects */
const precisionByZoomLevel: Record<number, number> = {
  0: 2,
  1: 3,
  2: 4,
  3: 5,
  4: 6,
  5: 7,
  6: 8,
  7: 10,
  8: 11,
  9: 12,
  10: 13,
  11: 14,
  12: 16,
  13: 17,
  14: 18,
  15: 19,
  16: 29,
  17: 29,
  18: 29,
  19: 29,
  20: 29,
  21: 29,
  22: 29,
  23: 29,
  24: 29,
  25: 29,
  26: 29,
  27: 29,
  28: 29,
  29: 29,
  30: 29,
};

const precisionByZoomLevelMedium: Record<number, number> = {
  0: 1,
  1: 2,
  2: 2,
  3: 4,
  4: 4,
  5: 6,
  6: 7,
  7: 8,
  8: 9,
  9: 11,
  10: 12,
  11: 13,
  12: 14,
  13: 15,
  14: 16,
  15: 17,
  16: 18,
  17: 29,
  18: 29,
  19: 29,
  20: 29,
  21: 29,
  22: 29,
  23: 29,
  24: 29,
  25: 29,
  26: 29,
  27: 29,
  28: 29,
  29: 29,
  30: 29,
};

const precisionByZoomLevelBig: Record<number, number> = {
  0: 1,
  1: 2,
  2: 2,
  3: 4,
  4: 4,
  5: 6,
  6: 7,
  7: 8,
  8: 9,
  9: 10,
  10: 11,
  11: 12,
  12: 13,
  13: 14,
  14: 15,
  15: 16,
  16: 19,
  17: 20,
  18: 29,
  19: 29,
  20: 29,
  21: 29,
  22: 29,
  23: 29,
  24: 29,
  25: 29,
  26: 29,
  27: 29,
  28: 29,
  29: 29,
  30: 29,
};
/* eslint-enable perfectionist/sort-objects */

const getPrecisionDetails = (
  zoom: number,
  organizationSize: OrganizationSize,
  offset: number = 0
): {
  minClusterSize: number;
  precision: number;
  precisionThreshold: number;
} => {
  const zoomLevels =
    organizationSize === "big"
      ? precisionByZoomLevelBig
      : organizationSize === "medium"
        ? precisionByZoomLevelMedium
        : precisionByZoomLevel;
  const precision = (zoomLevels[zoom] ?? zoom) + offset;
  const precisionThreshold = organizationSize === "small" ? 1000 : 500;
  loggingService.debug("getPrecision", {
    offset,
    organizationSize,
    precision,
    precisionThreshold,
    zoom,
  });
  return { minClusterSize: 50, precision, precisionThreshold };
};

export default getPrecisionDetails;
